import { LogEntryStatusCombinedProps } from './types';

const usePresenter = (props: LogEntryStatusCombinedProps): LogEntryStatusCombinedProps => {
  return props;
};

export default usePresenter;
